module.exports = __webpack_public_path__ + "img/android-close.5297827c.svg";